<template>
    <div class="memberRuleBox">
        <div class="imgLogoBox">
            <div class="scrollBox">
                <div class="article margin-15 bg-gray">
                    <div class="weui_article bg-white">
                        <h1 style="white-space:pre-line">{{ruleDataList.topic}}</h1>
                        <p v-if="ruleDataList.topicPic">
                            <img :src="`manager/fileserver/file/download?id=${ruleDataList.topicPic}`"
                                  class="img-thumbnail" width="100%" style="border: none;"/>
                        </p>
                        <p style="white-space:pre-line">{{ruleDataList.desc}}</p>

                        <section v-for="(item, index) in ruleDataList.contentItems" :key="index">
                            <div style="white-space:pre-line">{{item.desc}}</div>
                            <p v-for="(pic, idx) in item.pics" :key="idx">
                                <img :src="`manager/fileserver/file/download?id=${pic}`"
                                      class="img-thumbnail" width="100%"/>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "serviceContent",
        created(){
            this.ruleList = JSON.parse(this.$route.query.itemData)
            this.id = this.$route.query.id
        },
        mounted() {
            document.title = "服务中心"
            if(this.id == 1){
                this.$http.get('/sangto-wrm/base/content/getById',{ //获取会员规则详情
                    params:{
                        id:this.ruleList
                    }
                }).then(({data})=>{

                    this.ruleDataList = data.data
                })
            }else {
                let dt = new URLSearchParams()
                dt.append('id', this.ruleList)
                this.$http.post('/system/base/content/getById', dt).then(({data})=>{

                    this.ruleDataList = data.data
                })
            }



        },
        data(){
            return{
                ruleList:'',
                ruleDataList:'', //会员规则详情
            }
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped>
    .memberRuleBox{
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #fff;
        .imgLogoBox{
            position: absolute;
            /*top: 45px;*/
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            .scrollBox{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: #fff;
            }


        }
        .bg-gray {background-color: #f5f5f5!important;}
        .bg-white {background-color: #fff;}
        .margin-15{
            margin-top: 15px;
        }
        .article h1{
            font-size: 16px;
            font-weight: bold;
            color: red;
        }

        .article p{
            font-size: 14px;
        }


    }
</style>
